module.exports = __webpack_public_path__ + "static/media/integrationthird.1919e0c3.png";